"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Plugin base object.
 */
class PluginBase {
    /**
     *
     * @param {PluginDefinition} definition
     */
    constructor(definition) {
        this.definition = definition;
    }
    /**
     * Gets the plugin definitions of this plugin instance.
     *
     * @return {PluginDefinition}
     */
    getDefinition() {
        return this.definition;
    }
}
exports.default = PluginBase;
